var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"show-more",attrs:{"href":"#"},on:{"click":function($event){return _vm.$emit('showAll')}}},[_vm._v("Показать еще ")])}
var staticRenderFns = []

export { render, staticRenderFns }